import { ChangeEvent, createContext, Dispatch, SetStateAction } from 'react'
import { MainImage, UploadImageProviderProps } from '../types'
import { ImagesFromUploadImage } from '../types'

export interface IUploadImageContext extends UploadImageProviderProps {
  isOpen: boolean
  image: MainImage
  newImage: MainImage
  images: ImagesFromUploadImage[]
  view: string
  openModal: () => void
  closeModal: () => void
  setImage: Dispatch<SetStateAction<MainImage>>
  setNewImage: Dispatch<SetStateAction<MainImage>>
  setView: Dispatch<SetStateAction<string>>
  handleOnClick: () => void
  handleOnChange: (event: ChangeEvent<HTMLInputElement>) => void
}

const defaultValues: IUploadImageContext = {
  isOpen: false,
  view: '',
  isLoading: false,
  images: [],
  image: {},
  newImage: {},
  size: '',
  rounded: '',
  openModal: () => {},
  closeModal: () => {},
  setImage: () => {},
  setNewImage: () => {},
  setView: () => {},
  onUpdate: async () => true,
  onDelete: async () => true,
  onUpload: async () => true,
  handleOnClick: () => {},
  handleOnChange: () => {},
}

const UploadImageContext = createContext<IUploadImageContext>(defaultValues)

export default UploadImageContext
